import { IconProps } from './IconProps';

export const TickBlue = ({
  className,
  style,
  fill = '#0279e8',
  width = 13,
  height = 10,
}: {
  className?: string;
  style?: Record<string, unknown>;
  fill?: string;
  width?: number;
  height?: number;
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 13 10"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
    >
      <g
        id="Symbols"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="section-/-after-payment"
          transform="translate(-314.000000, -852.000000)"
          stroke={fill}
          strokeWidth="2"
        >
          <g
            id="section-/-footbar-/-PreOrder-Copy"
            transform="translate(0.000000, 826.000000)"
          >
            <g id="Group" transform="translate(315.000000, 27.000000)">
              <polyline
                id="Path"
                points="10.6666667 0 3.33333333 7.33333333 0 4"
              ></polyline>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

